export default __webpack_public_path__ + "img/74fbad2372132750f8ba1719e5dafa71.png";